/* eslint-disable sonarjs/no-collapsible-if */
/* eslint-disable sonarjs/no-use-of-empty-return-value */
/* eslint-disable sonarjs/no-duplicate-string */
/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable sonarjs/no-identical-functions */
/* eslint-disable sonarjs/cognitive-complexity */
import { Space, Row, Col, Button, message as toaster, Modal } from 'antd';
import styled from 'styled-components';
import { useDispatch, useSelector } from 'react-redux';
import moment from 'moment';
import { useHistory } from 'react-router-dom';
import { FieldArray, Formik } from 'formik';
import { groupBy, isArray, flattenDeep, flatten, isEmpty, cloneDeep } from 'lodash';
import { Form, Radio, DatePicker, Input as FormInput, Select } from 'formik-antd';
import PropTypes from 'prop-types';
import React, { useState, useEffect, Fragment, useRef, useMemo } from 'react';
import {
	initialValues,
	initialValuesAmortization,
	getTotalAmount,
	getBalanceAmount,
	getSplitedTotal,
	disableDateRanges,
	getAmortizationValidation,
	getAmount,
	SaveBtn,
	ClearBtn,
	ConfirmBtn,
	Label,
	BillType,
	addRemovePayment,
	NEFTRefCheck,
	UPIRefCheck,
	Bill,
	BillNo,
	AmountFilled,
	UTRInfo,
	UTRInforBox,
	ImageBox,
	getIndividualAmount,
} from 'components/pages/collection-app/invoice-controller';
import { Text, Box, Flex, Image } from 'atoms';
import {
	ClearConfirmation,
	DuplicateReferenceConfirmation,
	// AutoCompleteUpi,
	ConfirmBeforeUpdate,
} from 'components/pages/collection';
import { Debug } from 'forms/Debug';
// import { useQueryParams } from 'hooks';
import { theme } from 'styles/theme';
import { Rupee, Shimmer } from 'components';
import { getDateDiff, dateValidationCheck, getUserLocationData } from 'utils';
import { checkLocationPermission } from 'utils/location';
import { AR } from 'utils/constants';
import ManualMode from 'assets/ManualMode.svg';
import DynamicMode from 'assets/DynamicMode.svg';
import locationModalIllustration from 'assets/location-modal-illustration.png';
import {
	clearAllInvoices,
	getNewAmortizeLogic,
	// getSalesInvoicesList,
	saveInvoicesComplete,
	getBillBackReasons,
} from 'store/salesmanSlice';
import * as SVGICONS from 'utils/svg';
import { getMaxCashMaxAmount } from '../invoice-controller/amortizationController';
import ManualUPiEdit from '../ManualUPiEdit';
import DynamicQRCode from '../DynamicQRCode';
import { AutoCompleteUpi } from '../UPIAutoComplete';
// import { background } from 'styled-system';
// import ManualUPiEdit from '../ManualUPiEdit';

const BoxWrap = styled(Flex)`
	justify-content: space-between;
`;
// const BoxToolTip = styled(Box)`
// 	margin-left: 70px;
// 	margin-top: 10px;
// `;
// const ErrorImage = styled(Image)`
// 	margin-left: 90px;
// `;

export function getCashMaxAmount(invoices = []) {
	/**
	 * To calculate max allowed amount as cash collection for all bills
	 */

	const storeWise = invoices?.[0]?.store_cash_limit_allowed;

	const allInvoicesWise = invoices?.reduce(
		(acc, curr) => acc + Number(curr?.cash_limit_allowed),
		0
	);

	return Math.min(storeWise, allInvoicesWise);
}
const Error = styled(Text)`
	color: red;
	fomt-size: 10px;
`;

const FormInputError = styled(FormInput)`
	fomt-size: 10px;
`;
const { TextArea } = FormInput;
const { Option } = Select;
const NBB = 'No Bill Back';

function getTotal(values = []) {
	return values?.reduce((acc, curr) => acc + Number(curr.amount) || 0, 0);
}

function getFlattenTotal(values = []) {
	const result = Object.keys(values).map((key) => {
		if (values[key]?.length === 1) {
			return values[key];
		}
		const total = getTotal(values[key]) || 0;

		return [{ ...values[key][0], amount: total }];
	});

	return result?.length > 0 ? flatten(result) : undefined;
}

function getSplitInitValue(storeInvoices, totalOutstanding, isEditMode = false) {
	return storeInvoices?.map((item) => ({
		id: item?.id,
		amount: isEditMode ? getTotal(item?.payment) : undefined,
		current_outstanding_amount: Number(item?.initial_outstanding_amount),
		oldStatus: item?.status,
		status: isEditMode ? item?.status : undefined,
		reason: isEditMode ? item?.reason : undefined,
		remarks: isEditMode ? item?.remarks?.trim() : undefined,
		invoice_date: item?.invoice_date,
		invoice_age: getDateDiff(item?.invoice_date),
		billtype: item?.billtype,
		invoice_no: item?.invoice_no,
		totalOutstanding,
		oldData: item,
	}));
}

const style = {
	width: '100%',
	borderRadius: 0,
};

const status = ['RejectedByCashier'];
const edit_only_data = ['EDITDATA'];
const verifcation_status = ['VerifiedByCashier', 'UpiAutoVerified'];

const getBlockAmertization = (payments) => {
	console.log(payments, 'payments');
	const filteredPayments = payments.filter(
		(payment) => !verifcation_status.includes(payment.payment_verification_status)
	);

	console.log(filteredPayments, 'filteredPayments');

	const cashier_rejected_payments = filteredPayments.filter((payment) =>
		status.includes(payment?.payment_verification_status)
	);

	console.log(cashier_rejected_payments, 'cashier_rejected_payments');

	const cashier_rejected_data_payments = filteredPayments.filter((payment) =>
		edit_only_data.includes(payment?.state)
	);

	console.log(filteredPayments.length, 'filteredPayments');
	console.log(cashier_rejected_payments.length, 'cashier_rejected_payments');
	console.log(cashier_rejected_payments.length, 'cashier_rejected_data_payments');

	if (
		filteredPayments.length > 0 &&
		cashier_rejected_payments.length > 0 &&
		cashier_rejected_payments.length === cashier_rejected_data_payments.length
	) {
		return true;
	}

	return false;
};

export default function InvoiceAmortization({
	storeInvoices,
	totalOutstanding,
	isEditMode,
	previousUPIPayments = [],
	deliveryDate,
	outstandingAmount,
}) {
	const dispatch = useDispatch();
	const {
		banks = [],
		reasons = [],
		billBackReasons = [],
		store_data,
	} = useSelector((state) => state.salesman);
	const { me = {}, selectedSalesMan = {} } = useSelector((state) => state.user);

	console.log(storeInvoices, 'storeInvoices');

	console.log(store_data, 'store_datastore_data');
	console.log(isEditMode, 'isEditMode');

	const [block_lvl, set_blockblock_lvl] = useState('');
	const [showShimmer, setShowShimmer] = useState(true);

	let check_PERSIST;

	useEffect(() => {
		if (store_data?.payments.length > 0) {
			set_blockblock_lvl(store_data?.payments[0]?.state);
			setShowShimmer(false);
		} else {
			set_blockblock_lvl('');
			setShowShimmer(false);
		}
	}, [store_data]);

	useEffect(() => {
		dispatch(getBillBackReasons());
	}, [dispatch]);

	useEffect(() => {
		const checkAndRequestLocation = async () => {
			try {
				const permissionResult = await checkLocationPermission();

				if (permissionResult.state !== 'granted' && navigator.geolocation) {
					navigator.geolocation.getCurrentPosition(
						(position) => {
							console.log('Location permission granted on page load:', position);
						},
						(error) => {
							console.warn(
								'Location permission denied or error on page load:',
								error
							);
						},
						{
							enableHighAccuracy: true,
							timeout: 10000,
							maximumAge: 300000,
						}
					);
				}
			} catch (error) {
				console.warn('Error checking location permission on page load:', error);
			}
		};

		checkAndRequestLocation();
	}, []);

	console.log(totalOutstanding, check_PERSIST, block_lvl);

	const [formInitialValues, setFormInitialValues] = useState({
		...initialValuesAmortization,
		current_outstanding_amount: Number(totalOutstanding),
		store_id: store_data?.invoices?.[0]?.store_id,
		store_name: store_data?.store_info?.store_name,
		store_info: store_data?.store_info,
		splitInvoices: getSplitInitValue(storeInvoices, totalOutstanding),
	});
	// const { salesmanId = undefined } = useQueryParams();
	const [showClearConfirmation, setShowClearConfirmation] = useState(false);
	const [showDuplicateError, setShowDuplicateError] = useState(false);
	const [showUpdateConfirmation, setShowUpdateConfirmation] = useState(false);
	const [showDynamicQRCode, setShowDynamicQRCode] = useState(false);
	const [showManualUPI, setshowManualUPI] = useState(false);
	const [showUpiPopup, setShowUpiPopup] = useState(false);
	const [UPIRefFieldIndex, setUPIRefFieldIndex] = useState(0);
	// on create mode start the index from 0, on edit mode based on previous data change the initial value
	const [dynamicUPIData, setDynamicUPIData] = useState(null);
	const [manualModeEditData, setManualModeEditData] = useState({});
	const [dataManualUPiEdit, setDataManualUPiEdit] = useState({});
	const formRef = useRef();
	const history = useHistory();
	const [invalidData, setInvalidData] = useState({ upis: [], neft: [], message: [] });
	const [showLocationModal, setShowLocationModal] = useState(false);
	const [pendingSubmit, setPendingSubmit] = useState(null);

	const verifiedBy = useMemo(() => {
		const cashier = storeInvoices?.every(
			(item) => item?.invoice_verification_status === 'VerifiedByCashier'
		);
		const segregator = storeInvoices?.some(
			(item) =>
				item?.invoice_verification_status === 'VerifiedBySegregator' ||
				item?.invoice_verification_status?.includes('Cashier')
		);
		const delegatedSalesmanName = storeInvoices?.some((item) => item?.delegated_salesman_name);

		return { cashier, segregator, delegatedSalesmanName };
	}, [storeInvoices]);

	const [checkNullPDC, SetcheckNullPDC] = useState(0);

	function checkNullPDCFUnc() {
		if (deliveryDate?.cheque_credit_period === null) {
			SetcheckNullPDC(false);
		} else {
			SetcheckNullPDC(true);
		}
	}
	useEffect(() => {
		/**
		 * To Prefill the data - On Edit mode
		 */
		if (isEditMode) {
			/**
			 * On Edit Mode
			 */
			const newInit = {
				current_outstanding_amount: Number(totalOutstanding),
				store_id: storeInvoices?.[0]?.store_id,
				store_name: storeInvoices?.[0]?.store_name,
				update: 'true',
			};
			/**
			 * group the payment types by payment_type key
			 */

			const splited = getSplitInitValue(storeInvoices, totalOutstanding, isEditMode);

			const onlyPayment = flattenDeep(splited?.map((item) => item?.oldData?.payment));

			const checkRejectedStatus = onlyPayment?.filter(
				(item) => item?.payment_verification_status === 'RejectedByCashier'
			);

			const checkRBlockStatus = onlyPayment?.filter((item) => item?.block_edit_state);
			const validTypes = ['VerifiedBySegregator', 'VerifiedByCashier'];
			const checkForStoreStatus = storeInvoices?.filter((item) =>
				validTypes.includes(item?.invoice_verification_status)
			).length;

			const disbaledRadioBtn = storeInvoices.length === checkForStoreStatus;

			const groupedPayments = groupBy(onlyPayment, 'payment_type');

			// cash
			let cashDataPayment = {
				node: 1,
			};

			if (groupedPayments?.Cash && groupedPayments?.Cash.length > 0) {
				cashDataPayment = groupedPayments?.Cash[0];
			}

			let maInCashData = { node: 1 };

			if (groupedPayments?.Cash && groupedPayments?.Cash.length > 0) {
				maInCashData = groupedPayments?.Cash[0];
			}
			// UPI

			let upiData = groupBy(groupedPayments?.UPI, 'reference_number');

			upiData = getFlattenTotal(upiData) || [];

			// cheque

			let chequeData = groupBy(
				groupedPayments?.Cheque,
				(item) => `${item.reference_number}-${item.due_date}-${item.bank_id}`
			);

			chequeData = getFlattenTotal(chequeData);

			const blockAmertization = getBlockAmertization(store_data?.payments);

			console.log(blockAmertization, 'blockAmertization');

			// neft

			let neftData = groupBy(groupedPayments?.NEFT, 'reference_number');

			neftData = getFlattenTotal(neftData);

			/**
			 * other than old data we are adding, upi list data also if its not there in edit mode
			 */
			const onlyRefNo = upiData?.map((item) => item?.reference_number);
			let newonlyRefNofromApi = previousUPIPayments?.map((item) => item?.utr);

			newonlyRefNofromApi = newonlyRefNofromApi?.filter((item) => !onlyRefNo?.includes(item));
			newonlyRefNofromApi = previousUPIPayments?.filter((item) =>
				newonlyRefNofromApi?.includes(item?.utr)
			);
			newonlyRefNofromApi = newonlyRefNofromApi?.map((item) => ({
				id: Math.random(),
				reference_number: item?.utr,
				bank_statement_id: undefined,
				amount: item?.amount,
				type: 'qrcode',
			}));
			upiData = [...upiData, ...newonlyRefNofromApi];

			newInit.cash = getTotal(groupedPayments?.Cash) || '';
			newInit.upiData = upiData || initialValues?.upiData;
			newInit.chequeData = chequeData || initialValues?.chequeData;
			newInit.neftData = neftData || initialValues?.neftData;
			newInit.cashData = maInCashData;
			newInit.splitInvoices = splited;
			newInit.fillType = 'Manual';
			newInit.cashDataPayment = cashDataPayment;
			newInit.cashMaxLimit = getMaxCashMaxAmount(store_data); // to find max amount collected in cash
			newInit.store_info = store_data?.store_info;
			newInit.store_payments = store_data?.payments;
			newInit.store_payments_length = store_data?.payments.length;
			newInit.payment_info = onlyPayment;
			newInit.checkRejectedStatus = checkRejectedStatus;
			newInit.checkRejectedStatusLen = checkRejectedStatus?.length;
			newInit.checkRBlockStatusLen = checkRBlockStatus?.length;
			newInit.disbaledRadioBtn = disbaledRadioBtn;
			newInit.can_salesman_edit = store_data?.store_info?.can_salesman_edit;
			newInit.blockAmertization = blockAmertization;
			newInit.invoices_info = storeInvoices;

			setFormInitialValues({ ...newInit });
			if (upiData?.length > 0 && UPIRefFieldIndex === 0) {
				setUPIRefFieldIndex(upiData.length);
			}
		} else {
			/**
			 * On Create Mode
			 */
			setFormInitialValues({
				...initialValues,
				...(previousUPIPayments?.length > 0 && {
					upiData: previousUPIPayments?.map((item) => ({
						id: Math.random(),
						reference_number: item?.utr,
						bank_statement_id: undefined,
						amount: item?.amount,
						type: 'qrcode',
					})),
				}),
				current_outstanding_amount: Number(totalOutstanding),
				store_id: storeInvoices?.[0]?.store_id,
				store_name: storeInvoices?.[0]?.store_name,
				splitInvoices: getSplitInitValue(storeInvoices, totalOutstanding),
				cashMaxLimit: getMaxCashMaxAmount(store_data), // to find max amount collected in cash
				store_info: store_data?.store_info,
				can_salesman_edit: store_data?.store_info?.can_salesman_edit,
			});

			/**
			 * On first time form load, check if any already added QR code available
			 */

			if (previousUPIPayments?.length > 0 && UPIRefFieldIndex === 0) {
				setUPIRefFieldIndex(UPIRefFieldIndex + previousUPIPayments.length);
			}
		}

		checkNullPDCFUnc();

		return () => {
			setFormInitialValues({ ...initialValues });
		};
	}, [storeInvoices, totalOutstanding, isEditMode]);

	function addErrorData(upis, nefts, message, formToucher, data) {
		setInvalidData({ upis, neft: nefts, message });

		for (let i = 0; i < data.upiData.length; i += 1) {
			if (upis.find((v) => v === data.upiData[i].reference_number)) {
				formToucher(`upiData[${i}].reference_number`);
			}
		}

		for (let i = 0; i < data.neftData.length; i += 1) {
			if (nefts.find((v) => v === data.neftData[i].reference_number)) {
				formToucher(`neftData[${i}].reference_number`);
			}
		}
	}

	function handleRedirect() {
		if (me.type === AR) {
			history.push(`/invoices-collection?salesmanId=${selectedSalesMan?.id}`);
		} else {
			history.push('/invoices-collection');
		}
	}

	function clearBottomInvoices() {
		if (formRef?.current) {
			formRef.current.setFieldValue(`fillType`, undefined);
			formRef.current.values?.splitInvoices?.forEach((_, i) => {
				formRef.current.setFieldValue(`splitInvoices[${i}].amount`, undefined);
				formRef.current.setFieldValue(`splitInvoices[${i}].status`, undefined);
				formRef.current.setFieldValue(`splitInvoices[${i}].remarks`, undefined);
				formRef.current.setFieldValue(`splitInvoices[${i}].reason`, undefined);
			});
		}
	}

	const DateFormat = 'YYYY-MM-DD HH:mm:ss';

	function getLocalDate(date) {
		const localDate = moment(date).format(DateFormat);

		return moment(localDate).format('YYYY-MM-DD');
	}

	function getPaymentsDataNew(values) {
		return {
			cash:
				values?.cash > 0
					? [
							{
								payment_type: 'Cash',
								amount: values?.cash,
								master_id: isEditMode ? values?.cashData?.master_pid : null,
							},
					  ]
					: [],
			cheque:
				values?.chequeData.length > 0
					? values?.chequeData
							?.filter((item) => item?.amount && item?.reference_number)
							?.map((item) => ({
								payment_type: 'Cheque',
								reference_number: item?.reference_number,
								due_date: getLocalDate(item?.due_date),
								amount: item?.amount,
								bank_id: item?.bank_id,
								master_id: !isEditMode ? null : item?.master_pid,
							}))
					: null,
			neft:
				values?.neftData.length > 0
					? values?.neftData
							?.filter((item) => item?.amount && item?.reference_number)
							?.map((item) => ({
								payment_type: 'Neft',
								reference_number: item?.reference_number,
								amount: item?.amount,
								master_id: isEditMode ? item?.master_pid : null,
							}))
					: null,
			upi: values?.upiData
				?.filter((item) => item?.amount && item?.reference_number)
				.map((item) => ({
					payment_type: 'Upi',
					reference_number: item?.reference_number,
					amount: item?.amount,
					type: item?.type,
					master_id: isEditMode ? item?.master_pid : null,
				})),
		};
	}

	function toCheckManualSplit(values, setSubmitting) {
		const collected = cloneDeep(values);

		let isNoError = true;

		if (values?.fillType === 'Manual') {
			const total = getTotalAmount(values);
			const upi = getIndividualAmount(values?.upiData);
			const cheque = getIndividualAmount(values?.chequeData);
			const neft = getIndividualAmount(values?.neftData);
			let currentCash = values?.cash;
			let otherThanCash = upi + cheque + neft || 0;
			let added = 0;

			collected?.splitInvoices?.every((split) => {
				let error = '';
				const cash_limit_allowed = Number(split?.oldData?.cash_limit_allowed) || 0;

				if (split?.amount > 0) {
					error = `Error!, Invoice #${split?.invoice_no} allowed to collect only ${cash_limit_allowed} as cash`;

					if (cash_limit_allowed === 0) {
						if (otherThanCash < split?.amount) {
							isNoError = false;
						}
						otherThanCash -= split.amount;
						added += split.amount;
					} else if (cash_limit_allowed > 0) {
						if (cash_limit_allowed <= currentCash) {
							if (split?.amount <= cash_limit_allowed) {
								currentCash -= split.amount;
								added += split.amount;
							} else if (split?.amount >= cash_limit_allowed) {
								currentCash -= cash_limit_allowed;
								added += cash_limit_allowed;
							} else {
								console.log('wix bottle 43');
							}

							if (otherThanCash === 0 && currentCash > 0 && added === total) {
								isNoError = false;
							}
						} else if (cash_limit_allowed > currentCash) {
							if (split?.amount >= currentCash) {
								currentCash = 0;
								added += currentCash;
							} else if (split?.amount < currentCash) {
								currentCash -= split.amount;
								added += split.amount;
							}

							const balance = otherThanCash - currentCash;

							if (balance > 0) {
								// currentCash = 0;
								otherThanCash -= balance;
								added += split.amount;
							}
						}
					}
				}

				if (!isNoError) {
					toaster.error(error);
					setSubmitting(false);

					return false;
				}

				return true;
			});

			if (currentCash > 0 && isNoError) {
				isNoError = false;
				toaster.error(`${currentCash} Cash amount added extra`);
				setSubmitting(false);
			}
		}

		return isNoError;
	}

	const getAMountValidation = (amount) => {
		if (amount > 0) {
			return amount;
		}
		if (amount === '') {
			return 0;
		}

		return 0;
	};

	async function handleSubmit(values, { setErrors, setSubmitting, setFieldTouched }) {
		if (!toCheckManualSplit(values, setSubmitting)) {
			return false;
		}

		const payments = getPaymentsDataNew(values);

		// For new saves (not updates), location is mandatory
		let location = null;

		if (!values?.update) {
			location = await getUserLocationData();

			// Check if location data is available for new saves
			if (!location || (location.latitude === null && location.longitude === null)) {
				// Directly trigger browser's location permission dialog first
				if (navigator.geolocation) {
					navigator.geolocation.getCurrentPosition(
						() => {
							// Permission granted - retry the save automatically
							toaster.success('Location access granted successfully!');
							// Retry the submit with location now available
							handleSubmit(values, { setErrors, setSubmitting, setFieldTouched });
						},
						(error) => {
							// Permission denied or error - show our custom modal as fallback
							console.warn('Location permission denied or error:', error);
							setPendingSubmit({ values, setErrors, setSubmitting, setFieldTouched });
							setShowLocationModal(true);
						},
						{
							enableHighAccuracy: true,
							timeout: 10000,
							maximumAge: 300000, // 5 minutes
						}
					);
				} else {
					// Browser doesn't support geolocation - show our modal
					setPendingSubmit({ values, setErrors, setSubmitting, setFieldTouched });
					setShowLocationModal(true);
				}

				return false;
			}
		}

		const data = {
			invoices: values?.splitInvoices?.map((item) => ({
				id: item?.id,
				invoice_status_marked_by_salesman: item?.status,
				remarks_from_salesman: item?.remarks ?? '',
				...(values?.fillType === 'Manual' && {
					salesman_filled_amount: getAMountValidation(item?.amount) ?? null,
				}),
				...(item?.status === 'No Bill Back' && {
					reason_from_salesman: item?.reason ?? null,
				}),
				...(item?.status === 'Bill Back' && {
					reason_from_salesman: null,
					bill_back_reason: item?.reason ?? null,
				}),
				cash_limit_allowed: item?.oldData?.cash_limit_allowed,
				store_cash_limit_allowed: item?.oldData?.store_cash_limit_allowed,
			})),
			payments,
			...(location && { location }),
		};

		const statusesToCheck = ['EDITAMOUNTORDATA', 'EDITDATA', 'EDITAMOUNT'];

		if (values?.update) {
			const totalTransactions = Object.values(payments).reduce(
				(sum, arr) => sum + arr.length,
				0
			);
			const hasSpecificStatus = values?.store_payments.some((payment) =>
				statusesToCheck.includes(payment.state)
			);

			if (totalTransactions < values?.store_payments.length && hasSpecificStatus) {
				data.payments_deleted = true;
			}
		}

		if (values?.update) {
			data.update = values?.update;
		}

		if (values?.fillType === 'Manual') {
			data.manual = 'true';
		}

		return dispatch(saveInvoicesComplete(data, setErrors))
			.then(() => {
				// dispatch(getSalesInvoicesList(salesmanId));
				handleRedirect();
			})
			.catch((er) => {
				console.log('failed with 400', er);
				// toaster.error(`Error on Invoices save`);
				const rd = er?.response?.data;

				if (rd && er?.response.status === 400) {
					if (rd.mode === 'NEFT') {
						addErrorData([], rd.reference_numbers, rd.message, setFieldTouched, values);
					} else if (rd.mode === 'UPI') {
						addErrorData(rd.reference_numbers, [], rd.message, setFieldTouched, values);
					}
				} else {
					toaster.error('Unexpected error while processing request.');
				}
			})
			.finally(() => {
				setSubmitting(false);
			});
	}

	const handleCancel = () => {
		setShowDuplicateError(false);
	};

	const handleOk = () => {
		if (formRef?.current) {
			setShowDuplicateError(false);
			formRef.current.handleSubmit();
		}
	};

	const handleUpdateCancel = () => {
		setShowUpdateConfirmation(false);
	};

	const handleLocationPermissionRequest = async () => {
		try {
			// Directly use navigator.geolocation to ensure permission dialog appears
			if (!navigator.geolocation) {
				toaster.error('Geolocation is not supported by this browser');
				setShowLocationModal(false);
				if (pendingSubmit) {
					pendingSubmit.setSubmitting(false);
				}

				return;
			}

			// This will definitely trigger the browser's permission dialog
			navigator.geolocation.getCurrentPosition(
				() => {
					// Permission granted
					toaster.success('Location access granted successfully!');
					setShowLocationModal(false);

					// Retry the pending submit
					if (pendingSubmit) {
						const { values, setErrors, setSubmitting, setFieldTouched } = pendingSubmit;

						setPendingSubmit(null);
						// Retry the submit with location now available
						handleSubmit(values, { setErrors, setSubmitting, setFieldTouched });
					}
				},
				(error) => {
					// Permission denied or error
					console.warn('Location permission denied or error:', error);
					toaster.warning(
						'Location access denied. Please enable location in your browser settings and try again.'
					);
					setShowLocationModal(false);
					if (pendingSubmit) {
						pendingSubmit.setSubmitting(false);
					}
				},
				{
					enableHighAccuracy: true,
					timeout: 10000,
					maximumAge: 300000, // 5 minutes
				}
			);
		} catch (error) {
			console.warn('Error requesting location permission:', error);
			toaster.error('Error requesting location permission');
			setShowLocationModal(false);
			if (pendingSubmit) {
				pendingSubmit.setSubmitting(false);
			}
		}
	};

	const handleLocationModalCancel = () => {
		setShowLocationModal(false);
		if (pendingSubmit) {
			pendingSubmit.setSubmitting(false);
			setPendingSubmit(null);
		}
		toaster.info(
			'Location access is required to save collections. Please enable it and try again.'
		);
	};

	/**
	 * New way handling the clear all, with single api
	 */
	function handleUpdateOk() {
		if (formRef?.current) {
			const clearAllData = formRef?.current?.values?.splitInvoices?.map((item) => ({
				invoice_id: item?.id,
				invoice_no: item?.invoice_no,
				status: item?.status,
			}));

			dispatch(clearAllInvoices(clearAllData)).then((res) => {
				console.log('ress', res);
				setShowUpdateConfirmation(false);
				formRef.current.handleSubmit();
			});
		}
	}

	function triggerBEAmortizeLogic(values) {
		const data = {
			invoices: values?.splitInvoices?.map((item) => ({
				id: item?.id,
				cash_limit_allowed: item?.cash_limit_allowed,
				store_cash_limit_allowed: item?.store_cash_limit_allowed,
			})),
			payments: getPaymentsDataNew(values),
		};

		return dispatch(getNewAmortizeLogic(data)).then((res) => res?.data);
	}

	async function handleFillTypeChange(e, values, setFieldValue) {
		const total = getTotalAmount(values);

		if (total === 0) {
			/**
			 * without entering any amount if they click Manual/Auto,
			 * it will change all invoice status and Bill Back automatically
			 */
			values?.splitInvoices?.forEach((_, i) => {
				setFieldValue(`splitInvoices[${i}].status`, 'Bill Back');
				setFieldValue(`splitInvoices[${i}].amount`, undefined);
			});
		} else {
			/**
			 * Radio Manual, Auto change function
			 */
			values?.splitInvoices?.forEach((_, i) => {
				setFieldValue(`splitInvoices[${i}].amount`, undefined);
				setFieldValue(`splitInvoices[${i}].status`, undefined);
			});

			if (e?.target?.value === 'Auto') {
				/**
				 * If total is valid then only will fill the amount automatically
				 */
				if (total > 0 && values?.splitInvoices?.length > 0) {
					const amortizeData = await triggerBEAmortizeLogic(values);

					values?.splitInvoices?.forEach((item, i) => {
						// Below code is newly added backend Amortize Logic
						const result = amortizeData.find((amor) => amor?.invoice_id === item?.id);

						setFieldValue(`splitInvoices[${i}].status`, result?.suggested_status);
						setFieldValue(
							`splitInvoices[${i}].amount`,
							getTotal(result?.invoice_payments)
						);
						// setShowUpdateConfirmation(true);

						// Below code is manual spliting logic
						// /**
						//  * Based on inovice age date, fill the amount to each invoice automatically
						//  */
						// const outstanding = item.current_outstanding_amount;
						// let amount = 0;

						// if (total >= outstanding) {
						// 	/**
						// 	 * outstanding within the total range
						// 	 */
						// 	amount = outstanding;
						// 	total -= outstanding;
						// } else if (total <= outstanding && total !== 0) {
						// 	/**
						// 	 * outstanding exceeded the total amount
						// 	 */
						// 	amount = total;
						// 	total = 0;
						// }
						// setFieldValue(`splitInvoices[${i}].amount`, amount);
						// if (amount === outstanding) {
						// 	/**
						// 	 * if the filled amount is equal to outstanding amount then make it as auto Bill Back
						// 	 */
						// 	setFieldValue(`splitInvoices[${i}].status`, NBB);
						// }
					});
				} else if (e?.target?.value === 'Manual') {
					setFieldValue(`fillType`, 'Manual');
				} else {
					setFieldValue(`fillType`, undefined);
				}
			}
		}
	}

	// const verifcation_status = ['RejectedByCashier'];

	function handleManualEditMode(data, index, store_info) {
		if (data?.type === 'Manual' && store_info?.can_salesman_edit) {
			setDataManualUPiEdit({
				data,
				isManualEditMode: true,
				index,
			});
			setshowManualUPI(true);
		}
	}

	function handleUPIQRCodeClose() {
		setShowDynamicQRCode(false);
		setshowManualUPI(false);
		setDynamicUPIData(null);
	}

	function handleDeleteManualUPI() {
		setUPIRefFieldIndex(UPIRefFieldIndex - 1);
		setManualModeEditData({});
		handleUPIQRCodeClose();
	}

	function handleQRCodeSubmit(saveData = null) {
		if (saveData?.reference_number) {
			if (saveData?.manualModeEditData?.data?.id) {
				/**
				 * Upi data edit secttion
				 */
				const updateIndex = saveData?.manualModeEditData?.index;

				formRef?.current?.setFieldValue(
					`upiData[${updateIndex}].reference_number`,
					saveData?.reference_number
				);
				formRef?.current?.setFieldValue(
					`upiData[${updateIndex}].bank_statement_id`,
					saveData?.bank_statement_id
				);
				formRef?.current?.setFieldValue(
					`upiData[${updateIndex}].amount`,
					saveData?.upiAmount
				);

				// formRef?.current
				// 	?.validateForm()
				// 	.then(() => console.log('Revalidation Complete - AS'));

				setTimeout(() =>
					formRef.current?.setFieldTouched(
						`upiData[${updateIndex}].reference_number`,
						true
					)
				);
			} else {
				/**
				 * On new upi data adding section
				 */
				formRef?.current?.setFieldValue(`upiData[${UPIRefFieldIndex}].id`, Math.random());
				formRef?.current?.setFieldValue(
					`upiData[${UPIRefFieldIndex}].reference_number`,
					saveData?.reference_number
				);
				formRef?.current?.setFieldValue(
					`upiData[${UPIRefFieldIndex}].bank_statement_id`,
					saveData?.bank_statement_id
				);
				formRef?.current?.setFieldValue(
					`upiData[${UPIRefFieldIndex}].amount`,
					saveData?.upiAmount
				);
				formRef?.current?.setFieldValue(
					`upiData[${UPIRefFieldIndex}].type`,
					saveData?.type
				);
				setUPIRefFieldIndex(UPIRefFieldIndex + 1);
			}
			setDynamicUPIData(null);
		}
		handleUPIQRCodeClose();
	}

	// Block Edit function

	const disableAddingNewPayment = (storeinfo) => {
		// if salemam submit newkeytodisbale
		if (storeinfo?.can_salesman_edit === false) {
			return true;
		}
		if (storeinfo?.payments_edit === false) {
			return true;
		}

		return false;
	};

	// eslint-disable-next-line consistent-return
	const checkCashDisplayDiv = (cash_data, storeData) => {
		// if salemam submit newkeytodisbale
		if (storeData?.payments_edit && cash_data?.node) {
			return true;
		}
		if (cash_data?.node) {
			return false;
		}
		if (cash_data?.amount > 0) {
			return true;
		}
		if (cash_data === undefined && storeData?.payments_edit === false) {
			return false;
		}

		return true;
	};

	// disable the Cash
	const cashState = ['EDITAMOUNT', '', 'DEFAULT'];

	const checkdisableConditionOnCash = (val, store_info) => {
		if (store_info?.can_salesman_edit === false) {
			return true;
		}
		if (val?.block_edit_state) {
			return true;
		}

		if (val?.state === 'DEFAULT' && val?.block_edit_state) {
			return true;
		}

		if (cashState.includes(val?.state) || val?.state === undefined) {
			return false;
		}
		if (val?.state === 'PERSIST') {
			return true;
		}

		return true;
	};

	const checkUpiDisplayDiv = (upi_data, storeData) => {
		if (upi_data === undefined && storeData?.payments_edit === false) {
			return false;
		}
		if (upi_data?.amount > 0) {
			return true;
		}

		return true;
	};

	const checkCheqDisplayDiv = (storeData, cheq_data) => {
		if (cheq_data?.amount === undefined && storeData?.payments_edit === false) {
			return false;
		}
		if (cheq_data?.amount > 0) {
			return true;
		}

		return true;
	};

	const checkNeftDisplayDiv = (storeData, neft_data) => {
		if (neft_data?.amount === undefined && storeData?.payments_edit === false) {
			return false;
		}
		if (neft_data?.amount > 0) {
			return true;
		}

		return true;
	};

	const data_state = ['EDITDATA', 'EDITAMOUNTORDATA', '', 'DEFAULT'];
	const blocked_state = ['SETTLE', 'EDITAMOUNT'];

	const getDataStateCheck = (val, store) => {
		if (store?.can_salesman_edit === false) {
			return true;
		}
		if (val?.block_edit_state === 1) {
			return true;
		}

		if (blocked_state.includes(val?.state)) {
			return true;
		}
		if (store?.can_salesman_edit) {
			return false;
		}
		if (val?.block_edit_state === 0) {
			return false;
		}
		if (data_state.includes(val?.state)) {
			if (store?.can_salesman_edit === true) {
				return false;
			}
			if (store?.can_salesman_edit === false) {
				return true;
			}

			return false;
		}
		if (val?.state === undefined) {
			return false;
		}
		if (val?.state === 'PERSIST') {
			return false;
		}
		if (val?.state === 'DEFAULT' && val?.block_edit_state) {
			return true;
		}

		return false;
	};

	const edit_data = ['EDITAMOUNTORDATA', 'EDITDATA', 'DEFAULT', undefined];
	const getChequeDataStatus = (values) => {
		console.log('getChequeDataStatus', values);

		return values?.amount > 0 && edit_data.includes(values?.state);
	};

	const edit_block_data = ['EDITAMOUNT', 'SETTLE'];
	const getChequeBlockDataStatus = (values) => {
		console.log('getChequeBlockDataStatus', values);

		return edit_block_data.includes(values?.state);
	};
	const amount_state = ['EDITAMOUNT', 'EDITAMOUNTORDATA', '', 'DEFAULT'];
	const getAmountState = (val, store) => {
		if (val?.block_edit_state) {
			return true;
		}
		if (store?.can_salesman_edit === false) {
			return true;
		}

		if (amount_state.includes(val?.state)) {
			if (val?.block_edit_state) {
				return true;
			}

			return false;
		}
		if (val?.state === 'EDITDATA') {
			return true;
		}
		if (val?.state === undefined) {
			return false;
		}

		return true;
	};

	const neftONchannge = (e, setFieldValue, index, values) => {
		console.log(e, setFieldValue, index, values, 'neftONchannge');
		if (values?.master_pid) {
			console.log('values', values);
		} else {
			setFieldValue(`neftData[${index}].reference_number`, undefined);
		}
	};

	const getStatuForChequeDataRest = (val) => {
		if (amount_state.includes(val?.state)) {
			return false;
		}
		// eslint-disable-next-line padding-line-between-statements
		return true;
	};

	// eslint-disable-next-line consistent-return
	const getVerificationStatus = (val) => {
		if (val?.payment_verification_status === 'VerifiedByCashier') {
			return <SVGICONS.VerificationSVG />;
		}
		if (val?.payment_verification_status === 'RejectedByCashier') {
			return <SVGICONS.RejecctionSVG />;
		}

		return '';
	};

	const getSegStatus = (storeinfo) => {
		if (storeinfo?.payments_edit === false) {
			return false;
		}

		return true;
	};

	// const checkAmountAndSplit = (values) =>
	// 	UPIRefCheck(values?.upiData) ||
	// 	NEFTRefCheck(values?.neftData) ||
	// 	(getBalanceAmount(values) !== 0 && getSplitedTotal(values) > 0);

	// const checkUpdateDisable = (values, dirty, errors) => {
	// 	console.log(checkAmountAndSplit(values), 'checkAmountAndSplit');
	// 	console.log(values, 'checkUpdateDisable');
	// 	console.log(dirty, 'dirtycheckUpdateDisable');
	// 	console.log(errors, 'errorscheckUpdateDisable');

	// 	if (values?.store_info?.can_salesman_edit === false) {
	// 		return true;
	// 	}
	// 	if (getBalanceAmount(values) > 0) {
	// 		return true;
	// 	}

	// 	if (!isEmpty(errors)) {
	// 		return true;
	// 	}
	// 	if (!dirty) {
	// 		return true;
	// 	}
	// 	if (!isEmpty(errors)) {
	// 		return true;
	// 	}
	// 	// eslint-disable-next-line sonarjs/no-collapsible-if
	// 	if (dirty) {
	// 		console.log('falsefalse');
	// 		if (isEmpty(errors) || getBalanceAmount(values) !== 0) {
	// 			return false;
	// 		}
	// 	}

	// 	return false;
	// };

	const checkUpdateDisabled = (values, errors, dirty) => {
		if (values?.store_info?.can_salesman_edit === false) {
			return true;
		}

		return (
			(getBalanceAmount(values) !== 0 && getSplitedTotal(values) > 0) ||
			getBalanceAmount(values) !== 0 ||
			!isEmpty(errors) ||
			!dirty ||
			UPIRefCheck(values?.upiData) ||
			NEFTRefCheck(values?.neftData)
		);
	};

	const getRadioDisabled = (val) => {
		if (val?.can_salesman_edit === true) {
			if (val?.blockAmertization) {
				return true;
			}

			return false;
		}
		if (val?.can_salesman_edit === false) {
			return true;
		}
		if (val?.store_info?.payments_edit === false) {
			return false;
		}

		return true;
	};

	const getDisbaledColor = (val, mainValues) => {
		if (val?.block_edit_state) {
			if (mainValues?.can_salesman_edit === false) {
				return {
					background: '#f5f5f5',
				};
			}

			return {
				background: '#f5f5f5',
			};
		}
		if (mainValues?.can_salesman_edit === false) {
			return {
				background: '#f5f5f5',
			};
		}

		return {
			background: '#fff',
		};
	};

	return (
		<>
			{/* <button type="button" onClick={() => addErrorData(['12345678'], ['123456789'])}>
				Add errors
			</button> */}

			{showShimmer ? (
				<Shimmer />
			) : (
				<Box>
					<Box>
						<Formik
							enableReinitialize
							initialValues={formInitialValues}
							validationSchema={getAmortizationValidation(
								formInitialValues,
								isEditMode,
								invalidData
							)}
							onSubmit={handleSubmit}
							initialTouched={{
								upiData: true,
								chequeData: true,
								neftData: true,
								splitInvoices: formInitialValues?.splitInvoices?.map(() => ({
									reason: true,
									remarks: true,
									status: true,
								})),
								fillType: true,
							}}
							innerRef={formRef}
						>
							{({ values, errors, setFieldValue, isValid, dirty }) => (
								<Form
									layout="vertical"
									hideRequiredMark
									className={
										verifiedBy?.cashier ?? verifiedBy?.delegatedSalesmanName
											? 'invoice-formik-form disabled-div'
											: 'invoice-formik-form'
									}
									style={{
										padding: '0 1rem 2rem',
									}}
								>
									<Box>
										<Text textAlign="center" fontSize="10px">
											Cash limit for this store:{' '}
											<Text fontWeight="bold" as="span">
												<Rupee>{values?.cashMaxLimit}</Rupee>
											</Text>
										</Text>

										<Row
											justify="end"
											align="middle"
											className={values.fillType ? 'disabled-div--' : ''}
										>
											<Col span={20} className="invoice-form">
												{checkCashDisplayDiv(
													values?.cashData,
													values?.store_info
												) && (
													<Row
														justify="space-around"
														align="middle"
														className="invoice-form-first-row"
													>
														<Col span={8}>
															<BillType
																isValidAmount={getAmount(
																	values.cash
																)}
																className="btlr-4"
															>
																Cash
															</BillType>
															<Box className="verifcation-cash">
																{' '}
																{getVerificationStatus(
																	values.cashData
																)}
															</Box>
														</Col>
														<Col
															span={16}
															className="cash-error-in-form"
														>
															<Form.Item
																name="cash"
																hasFeedback={false}
																showValidateSuccess={false}
															>
																<FormInput
																	type="number"
																	min={1}
																	max={199999}
																	prefix="₹"
																	name="cash"
																	disabled={checkdisableConditionOnCash(
																		values?.cashDataPayment,
																		values?.store_info
																	)}
																/>
															</Form.Item>
														</Col>
													</Row>
												)}
												{checkUpiDisplayDiv(
													values?.upiData?.[0],
													values?.store_info
												) && (
													<Row justify="space-around" align="middle">
														<Col span={8}>
															<BillType>UPI</BillType>
														</Col>
														<Col span={16} className="center p-10">
															{/* {getSegStatus(values?.store_info)} */}
															<Button
																onClick={() => {
																	setShowDynamicQRCode(true);
																	setDynamicUPIData(null);
																	setManualModeEditData(null);
																}}
																disabled={disableAddingNewPayment(
																	values?.store_info
																)}
																className="center w-75"
																type="primary"
															>
																Scan QR
															</Button>
														</Col>
													</Row>
												)}

												{values?.upiData?.[0]?.amount &&
													values?.upiData?.map((rowData, index) => (
														<UTRInforBox
															key={rowData?.id}
															onClick={() =>
																handleManualEditMode(
																	rowData,
																	index,
																	values?.store_info
																)
															}
															style={getDisbaledColor(
																rowData,
																values
															)}
														>
															<Box className="verifcations-upi">
																{getVerificationStatus(rowData)}
															</Box>
															{/* // style={{
															// 	backgroundColor:
															// 		checkUPIbackGround(
															// 			values?.upiData?.[0],
															// 			values?.store_info
															// 		)
															// 			? '#f5f5f5'
															// 			: '',
															// }} */}
															<UTRInfo>
																<Flex
																	alignItems="center"
																	justifyContent="center"
																>
																	<ImageBox>
																		<Image
																			src={
																				rowData?.type ===
																				'qrcode'
																					? DynamicMode
																					: ManualMode
																			}
																			alt="ManualMode"
																			height={17}
																			width={18}
																		/>
																	</ImageBox>
																	<Flex
																		flexDirection="column"
																		pl="0.5rem"
																	>
																		<Text
																			fontSize="8px"
																			color="#656565"
																		>
																			UTR Reference Number:
																		</Text>
																		<Text
																			fontSize="10px"
																			color="#272727"
																		>
																			{
																				rowData?.reference_number
																			}
																		</Text>
																	</Flex>
																</Flex>
																<Text fontSize="13px">
																	<Rupee>{rowData?.amount}</Rupee>
																</Text>
															</UTRInfo>
															{errors?.upiData &&
																errors?.upiData[index]
																	?.reference_number && (
																	<Error>
																		{
																			errors?.upiData[index]
																				?.reference_number
																		}
																	</Error>
																)}
														</UTRInforBox>
													))}
												<FieldArray
													name="chequeData"
													render={(arrayHelpers) => (
														<div>
															{values?.chequeData?.map(
																(rowData, index) => (
																	<Fragment key={rowData?.id}>
																		{checkCheqDisplayDiv(
																			values?.store_info,
																			values?.chequeData?.[0]
																		) && (
																			<Row
																				justify="space-around"
																				align="middle"
																			>
																				<Col
																					span={8}
																					className="add-section"
																				>
																					<BillType
																						isValidAmount={getAmount(
																							values
																								.chequeData[
																								index
																							]
																								?.amount
																						)}
																					>
																						Cheque
																					</BillType>
																					<Box className="verifcations-be">
																						{getVerificationStatus(
																							values
																								.chequeData[
																								index
																							]
																						)}
																					</Box>
																					{checkNullPDC && (
																						<>
																							{}
																							<div></div>
																							{() =>
																								addRemovePayment(
																									arrayHelpers,
																									index,
																									'cheque'
																								)
																							}
																							{getSegStatus(
																								values?.store_info
																							) && (
																								<Button
																									onClick={() =>
																										addRemovePayment(
																											arrayHelpers,
																											index,
																											'cheque'
																										)
																									}
																									className="add-btn"
																									type="button"
																								>
																									{index ===
																									0
																										? '+'
																										: '-'}
																								</Button>
																							)}
																							{/* <Button
																						disabled={getSegStatus(
																							values?.store_info
																						)}
																						onClick={() =>
																							addRemovePayment(
																								arrayHelpers,
																								index,
																								'cheque'
																							)
																						}
																						className="add-btn"
																						type="button"
																					>
																						{index ===
																						0
																							? '+'
																							: '-'}
																					</Button> */}
																							<Box className="verifcations-be">
																								{getVerificationStatus(
																									values
																										.chequeData[
																										index
																									]
																								)}
																							</Box>
																						</>
																					)}
																				</Col>
																				<Col span={16}>
																					{checkNullPDC && (
																						<Form.Item
																							name={`chequeData[${index}].amount`}
																							hasFeedback={
																								false
																							}
																							showValidateSuccess={
																								false
																							}
																						>
																							<FormInput
																								type="number"
																								min={
																									0
																								}
																								prefix="₹"
																								name={`chequeData[${index}].amount`}
																								disabled={getAmountState(
																									values
																										.chequeData[
																										index
																									],

																									values?.store_info
																								)}
																								onChange={(
																									e
																								) => {
																									if (
																										e
																											.target
																											.value ===
																											'0' ||
																										(e
																											.target
																											.value ===
																											'' &&
																											getStatuForChequeDataRest(
																												values
																													.chequeData[
																													index
																												]
																											))
																									) {
																										setFieldValue(
																											`chequeData[${index}].reference_number`,
																											undefined
																										);
																										setFieldValue(
																											`chequeData[${index}].bank_id`,
																											undefined
																										);
																										setFieldValue(
																											`chequeData[${index}].due_date`,
																											undefined
																										);
																									}
																								}}
																							/>
																						</Form.Item>
																					)}
																					{!checkNullPDC &&
																						deliveryDate?.cheque_credit_period ==
																							null && (
																							<Form.Item
																								name={`chequeData[${index}].amount`}
																								hasFeedback={
																									false
																								}
																								showValidateSuccess={
																									false
																								}
																								className="show-pdc-error"
																							>
																								<FormInputError
																									type="string"
																									min={
																										0
																									}
																									prefix="₹"
																									name={`chequeData[${index}].amount`}
																									value="Error: Contact Support Team"
																									disabled
																								/>
																							</Form.Item>
																						)}
																				</Col>
																			</Row>
																		)}
																		{getChequeBlockDataStatus(
																			values.chequeData[index]
																		) && (
																			<Row>
																				<Col
																					span={24}
																					className="p-10 no-border"
																				>
																					<div className="invoice-form-controls">
																						<Row
																							justify="space-between"
																							align="middle"
																						>
																							<Col
																								span={
																									11
																								}
																							>
																								<div className="invoice-form-remarks">
																									<Form.Item
																										name={`chequeData[${index}].reference_number`}
																										hasFeedback={
																											false
																										}
																										showValidateSuccess={
																											false
																										}
																										label="*Cheque no:"
																										className="custom-label"
																										labelCol={{
																											span: 24,
																										}}
																										wrapperCol={{
																											span: 24,
																										}}
																									>
																										<FormInput
																											name={`chequeData[${index}].reference_number`}
																											placeholder="last 6 digits"
																											pattern="[0-9]*"
																											inputMode="numeric"
																											maxLength={
																												6
																											}
																											disabled={getDataStateCheck(
																												values
																													.chequeData[
																													index
																												],
																												values
																											)}
																										/>
																									</Form.Item>
																								</div>
																							</Col>
																							<Col
																								span={
																									12
																								}
																								className="invoice-form-remarks"
																							>
																								<Form.Item
																									name={`chequeData[${index}].bank_id`}
																									hasFeedback={
																										false
																									}
																									showValidateSuccess={
																										false
																									}
																									label="*Bank Name"
																									className="custom-label"
																									labelCol={{
																										span: 24,
																									}}
																									wrapperCol={{
																										span: 24,
																									}}
																								>
																									<Select
																										getPopupContainer={(
																											trigger
																										) =>
																											trigger.parentNode
																										}
																										name={`chequeData[${index}].bank_id`}
																										showSearch
																										optionFilterProp="children"
																										className="w-100"
																										placeholder="*Bank Name"
																										allowClear
																										filterOption={(
																											input,
																											option
																										) =>
																											option.children
																												.toLowerCase()
																												.indexOf(
																													input.toLowerCase()
																												) >=
																											0
																										}
																										disabled={getDataStateCheck(
																											values
																												.chequeData[
																												index
																											],
																											values
																										)}
																									>
																										{banks?.map(
																											(
																												bank
																											) => (
																												<Option
																													key={
																														bank.id
																													}
																													value={
																														bank?.id
																													}
																												>
																													{
																														bank?.name
																													}
																												</Option>
																											)
																										)}
																									</Select>
																								</Form.Item>
																							</Col>
																						</Row>
																						<Row
																							justify="space-between"
																							align="middle"
																						>
																							<Col
																								span={
																									12
																								}
																							>
																								<Form.Item
																									name={`chequeData[${index}].due_date`}
																									hasFeedback={
																										false
																									}
																									showValidateSuccess={
																										false
																									}
																									label="*Due Date"
																									className="custom-label"
																									labelCol={{
																										span: 24,
																									}}
																									wrapperCol={{
																										span: 24,
																									}}
																								>
																									<DatePicker
																										getPopupContainer={(
																											trigger
																										) =>
																											trigger.parentNode
																										}
																										name={`chequeData[${index}].due_date`}
																										className="w-100"
																										format="DD-MM-YYYY"
																										allowClear
																										picker="date"
																										disabledDate={disableDateRanges(
																											values,
																											deliveryDate
																										)}
																										disabled={getDataStateCheck(
																											values
																												.chequeData[
																												index
																											],
																											values
																										)}
																									/>
																								</Form.Item>
																							</Col>
																						</Row>
																					</div>
																				</Col>
																			</Row>
																		)}

																		{getChequeDataStatus(
																			values.chequeData[index]
																		) && (
																			<Row>
																				<Col
																					span={24}
																					className="p-10 no-border"
																				>
																					<div className="invoice-form-controls">
																						<Row
																							justify="space-between"
																							align="middle"
																						>
																							<Col
																								span={
																									11
																								}
																							>
																								<div className="invoice-form-remarks">
																									<Form.Item
																										name={`chequeData[${index}].reference_number`}
																										hasFeedback={
																											false
																										}
																										showValidateSuccess={
																											false
																										}
																										label="*Cheque no:"
																										className="custom-label"
																										labelCol={{
																											span: 24,
																										}}
																										wrapperCol={{
																											span: 24,
																										}}
																									>
																										<FormInput
																											name={`chequeData[${index}].reference_number`}
																											placeholder="last 6 digits"
																											pattern="[0-9]*"
																											inputMode="numeric"
																											maxLength={
																												6
																											}
																											disabled={getDataStateCheck(
																												values
																													.chequeData[
																													index
																												],
																												values
																											)}
																										/>
																									</Form.Item>
																								</div>
																							</Col>
																							<Col
																								span={
																									12
																								}
																								className="invoice-form-remarks"
																							>
																								<Form.Item
																									name={`chequeData[${index}].bank_id`}
																									hasFeedback={
																										false
																									}
																									showValidateSuccess={
																										false
																									}
																									label="*Bank Name"
																									className="custom-label"
																									labelCol={{
																										span: 24,
																									}}
																									wrapperCol={{
																										span: 24,
																									}}
																								>
																									<Select
																										getPopupContainer={(
																											trigger
																										) =>
																											trigger.parentNode
																										}
																										disabled={getDataStateCheck(
																											values
																												.chequeData[
																												index
																											],
																											values
																										)}
																										name={`chequeData[${index}].bank_id`}
																										showSearch
																										optionFilterProp="children"
																										className="w-100"
																										placeholder="*Bank Name"
																										allowClear
																										filterOption={(
																											input,
																											option
																										) =>
																											option.children
																												.toLowerCase()
																												.indexOf(
																													input.toLowerCase()
																												) >=
																											0
																										}
																									>
																										{banks?.map(
																											(
																												bank
																											) => (
																												<Option
																													key={
																														bank.id
																													}
																													value={
																														bank?.id
																													}
																												>
																													{
																														bank?.name
																													}
																												</Option>
																											)
																										)}
																									</Select>
																								</Form.Item>
																							</Col>
																						</Row>
																						<Row
																							justify="space-between"
																							align="middle"
																						>
																							<Col
																								span={
																									12
																								}
																							>
																								<Form.Item
																									name={`chequeData[${index}].due_date`}
																									hasFeedback={
																										false
																									}
																									showValidateSuccess={
																										false
																									}
																									label="*Due Date"
																									className="custom-label"
																									labelCol={{
																										span: 24,
																									}}
																									wrapperCol={{
																										span: 24,
																									}}
																								>
																									<DatePicker
																										getPopupContainer={(
																											trigger
																										) =>
																											trigger.parentNode
																										}
																										name={`chequeData[${index}].due_date`}
																										className="w-100"
																										format="DD-MM-YYYY"
																										allowClear
																										picker="date"
																										disabled={getDataStateCheck(
																											values
																												.chequeData[
																												index
																											],
																											values
																										)}
																										disabledDate={disableDateRanges(
																											values,
																											deliveryDate
																										)}
																									/>
																								</Form.Item>
																							</Col>
																						</Row>
																					</div>
																				</Col>
																			</Row>
																		)}
																	</Fragment>
																)
															)}
														</div>
													)}
												/>
												<FieldArray
													name="neftData"
													render={(arrayHelpers) => (
														<div>
															{values?.neftData?.map(
																(rowData, index) => (
																	<Fragment key={rowData?.id}>
																		{checkNeftDisplayDiv(
																			values?.store_info,
																			values?.neftData?.[0]
																		) && (
																			<Row
																				justify="space-around"
																				align="middle"
																				className={
																					values.neftData
																						.length -
																						1 ===
																					index
																						? 'invoice-form-last-row'
																						: 'invoice-form'
																				}
																			>
																				<Col
																					span={8}
																					className="add-section"
																				>
																					<BillType
																						isValidAmount={getAmount(
																							values
																								.neftData[
																								index
																							]
																								?.amount
																						)}
																					>
																						NEFT
																					</BillType>
																					{getSegStatus(
																						values?.store_info
																					) && (
																						<Button
																							onClick={() =>
																								addRemovePayment(
																									arrayHelpers,
																									index,
																									'neft'
																								)
																							}
																							className="add-btn"
																							type="button"
																						>
																							{index ===
																							0
																								? '+'
																								: '-'}
																						</Button>
																					)}

																					<Box className="verifcations-be">
																						{getVerificationStatus(
																							values
																								.neftData[
																								index
																							]
																						)}
																					</Box>
																				</Col>
																				<Col span={16}>
																					<Form.Item
																						name={`neftData[${index}].amount`}
																						hasFeedback={
																							false
																						}
																						showValidateSuccess={
																							false
																						}
																					>
																						<FormInput
																							type="number"
																							min={0}
																							prefix="₹"
																							name={`neftData[${index}].amount`}
																							onChange={(
																								e
																							) => {
																								neftONchannge(
																									e,
																									setFieldValue,
																									index,
																									values
																										?.neftData?.[
																										index
																									]
																								);
																								// if (
																								// 	e
																								// 		.target
																								// 		.value ===
																								// 		'0' ||
																								// 	e
																								// 		.target
																								// 		.value ===
																								// 		''
																								// ) {
																								// 	setFieldValue(
																								// 		`neftData[${index}].reference_number`,
																								// 		undefined
																								// 	);
																								// }
																							}}
																							disabled={getAmountState(
																								values
																									.neftData[
																									index
																								],

																								values?.store_info
																							)}
																						/>
																					</Form.Item>
																				</Col>
																			</Row>
																		)}

																		{getAmount(
																			values.neftData[index]
																				?.amount
																		) && (
																			<>
																				<Box></Box>
																				<Row
																					justify="space-around"
																					align="middle"
																					className={
																						values
																							.neftData
																							.length -
																							1 ===
																						index
																							? 'invoice-form-last-row'
																							: 'invoice-form'
																					}
																				>
																					<Col
																						span={24}
																						className="pt-10 px-10 no-border"
																					>
																						<Box
																							width="100%"
																							className="invoice-form-remarks"
																						>
																							<Form.Item
																								name={`neftData[${index}].reference_number`}
																								hasFeedback={
																									false
																								}
																								showValidateSuccess={
																									false
																								}
																								label="* Ref no:"
																								className="custom-label"
																								labelCol={{
																									span: 24,
																								}}
																								wrapperCol={{
																									span: 24,
																								}}
																							>
																								<BoxWrap>
																									<FormInput
																										name={`neftData[${index}].reference_number`}
																										placeholder="Enter Ref.no"
																										minLength={
																											6
																										}
																										maxLength={
																											22
																										}
																										disabled={getDataStateCheck(
																											values
																												.neftData[
																												index
																											],
																											values
																										)}
																									/>
																								</BoxWrap>
																							</Form.Item>
																						</Box>
																					</Col>
																				</Row>
																			</>
																		)}
																	</Fragment>
																)
															)}
														</div>
													)}
												/>
											</Col>
										</Row>
										<Row>
											<Col span={24}>
												<Text
													fontSize="12px"
													fontWeight="300"
													py="10px"
													textAlign="left"
												>
													Total: <span>₹{getTotalAmount(values)}</span>
												</Text>
											</Col>
										</Row>
										<Row align="middle">
											<Col span={12}>
												<AmountFilled
													isValid={getBalanceAmount(values) >= 0}
													disabled={getRadioDisabled(values)}
													style={{
														backgroundColor: getRadioDisabled(values)
															? '#f5f5f5'
															: '',
													}}
												>
													<span className="label">
														Amount to be filled
													</span>
													<span className="value">
														₹{getBalanceAmount(values)}
													</span>
												</AmountFilled>
											</Col>
											<Col span={12} className="invoice-form-controls right">
												<Form.Item
													name="fillType"
													hasFeedback={false}
													showValidateSuccess={false}
												>
													<Radio.Group
														name="fillType"
														size="large"
														disabled={getRadioDisabled(values)}
														onChange={(e) =>
															handleFillTypeChange(
																e,
																values,
																setFieldValue
															)
														}
													>
														<Space
															direction="horizontal"
															className="custom-radio custom-big-radio"
														>
															<Radio value="Manual">
																<Label noMinWidth>Manual</Label>
															</Radio>
															<Radio value="Auto">
																<Label noMinWidth>Auto</Label>
															</Radio>
														</Space>
													</Radio.Group>
												</Form.Item>
											</Col>
										</Row>
										{/* Show error if collected amount and splited amount is not match */}
										{getBalanceAmount(values) !== 0 &&
											getSplitedTotal(values) > 0 && (
												<Flex
													justifyContent="center"
													alignItems="center"
													mt="1rem"
												>
													<Text
														as="p"
														color="#ff4d4f"
														fontSize="12px"
														textAlign="center"
													>
														Entered amount must be fully adjusted to
														invoices
													</Text>
												</Flex>
											)}
										<FieldArray
											name="splitInvoices"
											render={() => (
												<div
													className={
														!values?.fillType
															? 'disabled-div mt-15'
															: 'mt-15'
													}
												>
													{values?.splitInvoices?.map((store, index) => (
														<Bill
															key={store?.id}
															flexDirection="column"
															isLast={
																index ===
																values.splitInvoices.length - 1
															}
														>
															<Flex justifyContent="space-between">
																<Flex flexDirection="column">
																	<BillNo>
																		{store?.invoice_no}
																	</BillNo>
																	<Flex color={theme.colors.Onyx}>
																		<Text
																			fontSize="10px"
																			pr="1rem"
																		>
																			{dateValidationCheck(
																				store?.invoice_date
																			)
																				? moment(
																						store?.invoice_date
																				  ).format(
																						'DD-MM-YY'
																				  )
																				: 'NA'}
																		</Text>
																		<Text fontSize="10px">
																			{dateValidationCheck(
																				store?.invoice_date
																			)
																				? getDateDiff(
																						store?.invoice_date
																				  )
																				: 'NA'}{' '}
																			days
																		</Text>
																	</Flex>
																	<Box fontSize="10px">
																		<Text>
																			Allowed Cash Limit
																			{' : '}
																			<Rupee>
																				{Number(
																					values
																						?.splitInvoices[
																						index
																					]?.oldData
																						?.cash_limit_allowed
																				)?.toFixed(2)}
																			</Rupee>
																		</Text>
																		{/* <Text>
															Ref ID{' : '}
															{Number(
																values?.splitInvoices[index]?.id
															)}
														</Text> */}
																	</Box>
																</Flex>
																<Form.Item
																	name={`splitInvoices[${index}].status`}
																	hasFeedback={false}
																	showValidateSuccess={false}
																	className="status-error-in-form"
																>
																	<Radio.Group
																		name={`splitInvoices[${index}].status`}
																		size="large"
																		// disabled={verifiedBy?.segregator}
																		disabled={getRadioDisabled(
																			values
																		)}
																		onChange={(e) => {
																			setFieldValue(
																				`splitInvoices[${index}].status`,
																				e.target.value
																			);
																			setFieldValue(
																				`splitInvoices[${index}].reason`,
																				undefined
																			);
																		}}
																	>
																		<Space
																			direction="horizontal"
																			className="custom-radio"
																		>
																			<Radio value={NBB}>
																				<Label noMinWidth>
																					<Text maxWidth="40px">
																						{values
																							.splitInvoices[
																							index
																						]
																							.billtype ===
																						'Bill'
																							? 'Invoice Settled'
																							: 'Voucher Settled'}
																					</Text>
																				</Label>
																			</Radio>
																			<Radio value="Bill Back">
																				<Label noMinWidth>
																					<Text maxWidth="40px">
																						{values
																							.splitInvoices[
																							index
																						]
																							.billtype ===
																						'Bill'
																							? 'Invoice Returned'
																							: 'Voucher Returned'}
																					</Text>
																				</Label>
																			</Radio>
																		</Space>
																	</Radio.Group>
																</Form.Item>
															</Flex>
															<Flex
																justifyContent="space-between"
																alignItems="center"
															>
																<Flex
																	flexDirection="column"
																	mr="1rem"
																>
																	<Box
																		fontSize="14px"
																		color={
																			theme.colors.EerieBlack
																		}
																	>
																		<Rupee>
																			{
																				store?.current_outstanding_amount
																			}
																		</Rupee>
																	</Box>
																	<Text fontSize="10px">
																		{store?.oldStatus}
																	</Text>
																</Flex>
																<Box maxWidth="60%" my="1rem">
																	<Form.Item
																		name={`splitInvoices[${index}].amount`}
																		hasFeedback={false}
																		showValidateSuccess={false}
																	>
																		<FormInput
																			type="number"
																			min={0}
																			prefix="₹"
																			placeholder="Enter amount here"
																			name={`splitInvoices[${index}].amount`}
																			disabled={getRadioDisabled(
																				values
																			)}
																			style={{
																				backgroundColor:
																					getRadioDisabled(
																						values
																					)
																						? '#f5f5f5'
																						: '',
																			}}
																		/>
																	</Form.Item>
																</Box>
															</Flex>
															{(values?.splitInvoices[index]?.amount <
																store?.current_outstanding_amount ||
																!values?.splitInvoices[index]
																	.amount) && (
																<Box>
																	<Form.Item
																		name={`splitInvoices[${index}].reason`}
																		hasFeedback={false}
																		showValidateSuccess={false}
																		label="*Reason"
																		className="custom-label"
																		labelCol={{
																			span: 24,
																		}}
																		wrapperCol={{
																			span: 24,
																		}}
																	>
																		<Select
																			getPopupContainer={(
																				trigger
																			) => trigger.parentNode}
																			name={`splitInvoices[${index}].reason`}
																			showSearch
																			optionFilterProp="children"
																			placeholder="*Reason"
																			allowClear
																			filterOption={(
																				input,
																				option
																			) =>
																				option.children
																					.toLowerCase()
																					.indexOf(
																						input.toLowerCase()
																					) >= 0
																			}
																			className="reason-dropdown"
																		>
																			{(values?.splitInvoices[
																				index
																			]?.status ===
																			'Bill Back'
																				? billBackReasons
																				: reasons
																			)?.map((item) => (
																				<Option
																					key={item.id}
																					value={item?.id}
																				>
																					{item?.reason}
																				</Option>
																			))}
																		</Select>
																	</Form.Item>
																</Box>
															)}
															<Box className="invoice-form-remarks">
																<Form.Item
																	name={`splitInvoices[${index}].remarks`}
																	label="Remarks"
																	hasFeedback={false}
																	showValidateSuccess={false}
																	className="custom-label"
																	labelCol={{ span: 24 }}
																	wrapperCol={{ span: 24 }}
																>
																	<TextArea
																		className="full-remarks"
																		name={`splitInvoices[${index}].remarks`}
																		placeholder="Remarks"
																		style={{
																			height: 40,
																			width: '100%',
																		}}
																		disabled={getRadioDisabled(
																			values
																		)}
																	/>
																</Form.Item>
															</Box>
														</Bill>
													))}
												</div>
											)}
										/>
										{!isArray(errors?.chequeData) && (
											<Flex justifyContent="center" alignItems="center">
												<Text
													as="p"
													color="#ff4d4f"
													fontSize="12px"
													maxWidth="250px"
													textAlign="center"
												>
													{errors?.chequeData}
												</Text>
											</Flex>
										)}
										{NEFTRefCheck(values?.neftData) && (
											<Flex justifyContent="center" alignItems="center">
												<Text
													as="p"
													color="#ff4d4f"
													fontSize="12px"
													maxWidth="250px"
													textAlign="center"
												>
													* Duplicate NEFT Reference numbers, please check
													it
												</Text>
											</Flex>
										)}
										{UPIRefCheck(values?.upiData) && (
											<Flex justifyContent="center" alignItems="center">
												<Text
													as="p"
													color="#ff4d4f"
													fontSize="12px"
													maxWidth="250px"
													textAlign="center"
												>
													* Duplicate UPI Reference numbers, please check
													it
												</Text>
											</Flex>
										)}
										{!verifiedBy?.cashier && (
											<Row
												className="mt-15"
												justify="space-around"
												align="middle"
											>
												<Col span={12} className="left">
													{!verifiedBy?.segregator && (
														<ClearBtn
															type="button"
															onClick={() =>
																setShowClearConfirmation(true)
															}
															style={{
																width: '100%',
															}}
															disabled={getRadioDisabled(values)}
														>
															Clear
														</ClearBtn>
													)}
												</Col>
												<Col span={12} className="right">
													{NEFTRefCheck(values?.neftData) &&
													UPIRefCheck(values?.upiData) ? (
														<ConfirmBtn
															disabled={
																!isValid ||
																getBalanceAmount(values) !== 0 ||
																!isEmpty(errors) ||
																!dirty ||
																UPIRefCheck(values?.upiData) ||
																NEFTRefCheck(values?.neftData)
															}
															onClick={() =>
																setShowDuplicateError(true)
															}
															style={style}
														>
															{isEditMode ? 'Update3' : 'Save'}
														</ConfirmBtn>
													) : (
														<SaveBtn
															style={style}
															disabled={checkUpdateDisabled(
																values,
																errors,
																dirty
															)}
														>
															{isEditMode ? 'Update' : 'Save'}
														</SaveBtn>
													)}
												</Col>
											</Row>
										)}
										{process.env.NODE_ENV === 'development' && <Debug />}
										{showDynamicQRCode && (
											<DynamicQRCode
												visible={showDynamicQRCode}
												handleCancel={handleUPIQRCodeClose}
												totalOutstanding={
													Number(totalOutstanding) -
													getBalanceAmount(values)
												}
												outstanding={Number(outstandingAmount)}
												upiData={me?.upi || selectedSalesMan?.upi}
												storeData={storeInvoices?.[0]}
												UPIRefFieldIndex={UPIRefFieldIndex}
												dynamicUPIData={dynamicUPIData}
												setDynamicUPIData={setDynamicUPIData}
												manualModeEditData={manualModeEditData}
												formRef={formRef}
												handleDeleteManualUPI={handleDeleteManualUPI}
												handleQRCodeSubmit={handleQRCodeSubmit}
												storeInvoices={storeInvoices}
												values={values}
											/>
										)}

										{showManualUPI && (
											<ManualUPiEdit
												visible={showManualUPI}
												handleCancel={handleUPIQRCodeClose}
												totalOutstanding={
													Number(totalOutstanding) -
													getBalanceAmount(values)
												}
												upiData={me?.upi || selectedSalesMan?.upi}
												storeData={storeInvoices?.[0]}
												UPIRefFieldIndex={UPIRefFieldIndex}
												dynamicUPIData={dynamicUPIData}
												setDynamicUPIData={setDynamicUPIData}
												manualModeEditData={dataManualUPiEdit}
												formRef={formRef}
												handleDeleteManualUPI={handleDeleteManualUPI}
												handleQRCodeSubmit={handleQRCodeSubmit}
												storeInvoices={storeInvoices}
												storeInfo={store_data}
											/>
										)}
									</Box>
								</Form>
							)}
						</Formik>
						<DuplicateReferenceConfirmation
							visible={showDuplicateError}
							handleOk={handleOk}
							handleCancel={handleCancel}
						/>
						<ConfirmBeforeUpdate
							visible={showUpdateConfirmation}
							handleOk={handleUpdateOk}
							handleCancel={handleUpdateCancel}
						/>
						<ClearConfirmation
							visible={showClearConfirmation}
							onClose={() => setShowClearConfirmation(false)}
							onClear={clearBottomInvoices}
							infoText="Are you sure want to clear the splited invoices details"
						/>
						{showUpiPopup && (
							<AutoCompleteUpi
								setShowUpiPopup={setShowUpiPopup}
								showUpiPopup={showUpiPopup}
								storeData={storeInvoices?.[0]}
								formRef={formRef}
								UPIRefFieldIndex={UPIRefFieldIndex}
							/>
						)}

						{/* Location Permission Modal */}
						<Modal
							title={null}
							open={showLocationModal}
							onCancel={handleLocationModalCancel}
							centered
							maskClosable={false}
							width={311}
							style={{
								borderRadius: '7px',
							}}
							bodyStyle={{
								padding: '12px 24px',
								textAlign: 'center',
								borderRadius: '7px',
							}}
							footer={null}
						>
							<div
								style={{
									display: 'flex',
									flexDirection: 'column',
									alignItems: 'center',
									gap: '24px',
								}}
							>
								{/* Header with Icon and Title */}
								<div
									style={{
										display: 'flex',
										flexDirection: 'column',
										alignSelf: 'stretch',
										gap: '12px',
									}}
								>
									<div
										style={{
											display: 'flex',
											alignItems: 'center',
											gap: '9px',
										}}
									>
										<svg
											width="24"
											height="24"
											viewBox="0 0 24 24"
											fill="none"
											xmlns="http://www.w3.org/2000/svg"
										>
											<path
												d="M13 9C13 9.26522 12.8946 9.51957 12.7071 9.70711C12.5196 9.89464 12.2652 10 12 10C11.7348 10 11.4804 9.89464 11.2929 9.70711C11.1054 9.51957 11 9.26522 11 9C11 8.73478 11.1054 8.48043 11.2929 8.29289C11.4804 8.10536 11.7348 8 12 8C12.2652 8 12.5196 8.10536 12.7071 8.29289C12.8946 8.48043 13 8.73478 13 9Z"
												stroke="black"
												strokeWidth="2"
												strokeLinejoin="round"
											/>
											<path
												d="M17.5 9.5C17.5 12.538 15.5 16 12 20C8.5 16 6.5 12.538 6.5 9.5C6.5 8.04131 7.07946 6.64236 8.11091 5.61091C9.14236 4.57946 10.5413 4 12 4C13.4587 4 14.8576 4.57946 15.8891 5.61091C16.9205 6.64236 17.5 8.04131 17.5 9.5Z"
												stroke="black"
												strokeWidth="2"
												strokeLinejoin="round"
											/>
										</svg>
										<span
											style={{
												fontWeight: 600,
												fontSize: '12px',
												lineHeight: '15px',
												textTransform: 'capitalize',
												color: '#000000',
											}}
										>
											Location Access Required
										</span>
									</div>

									{/* Instructions Text */}
									<div
										style={{
											width: '100%',
											color: '#848484',
										}}
									>
										<p
											style={{
												margin: 0,
												fontStyle: 'bold',
												marginBottom: '16px',
												fontSize: '12px',
											}}
										>
											Follow Steps Below to Re-enable Location Prompt.
										</p>
										<ol
											style={{
												margin: 0,
												padding: 0,
												fontSize: '11px',
												display: 'flex',
												flexDirection: 'column',
												gap: '8px',
											}}
										>
											<li>
												1. Click the three dots menu (...) in the top-right
												corner of your Mobile browser
											</li>
											<li>2. Then Select Delete browsing data.</li>
											<li>
												3. Ensure that You have chosen Last 1 hour, and then
												click Delete Data.
											</li>
										</ol>
									</div>
								</div>

								{/* Illustration */}
								<div>
									<img
										src={locationModalIllustration}
										alt="Location permission steps"
										style={{
											maxWidth: '100%',
											height: 'auto',
											display: 'block',
										}}
									/>
								</div>

								{/* Allow Button */}
								<div
									style={{
										display: 'flex',
										justifyContent: 'center',
										width: '100%',
									}}
								>
									<Button
										key="allow"
										type="primary"
										onClick={handleLocationPermissionRequest}
										style={{
											backgroundColor: '#007FFF',
											borderColor: '#007FFF',
											borderRadius: '3px',
											height: 'auto',
											padding: '8px 24px',
											fontSize: '10px',
											fontWeight: 500,
											lineHeight: '1.21em',
											textTransform: 'uppercase',
											width: '181px',
										}}
									>
										Allow
									</Button>
								</div>
							</div>
						</Modal>
					</Box>
				</Box>
			)}
		</>
	);
}

InvoiceAmortization.propTypes = {
	storeInvoices: PropTypes.arrayOf(
		PropTypes.shape({
			status: PropTypes.string,
			reason: PropTypes.number,
			remarks: PropTypes.string,
			paid: PropTypes.number,
			billtype: PropTypes.string,
			payment: PropTypes.array,
			amount: PropTypes.number,
			initial_outstanding_amount: PropTypes.string,
			current_outstanding_amount: PropTypes.string,
			verified_by_segregator_id: PropTypes.number,
			verified_by_cashier_id: PropTypes.number,
			delegated_salesman_name: PropTypes.string,
			id: PropTypes.number,
			store_id: PropTypes.number,
			store_name: PropTypes.string,
			invoice_verification_status: PropTypes.string,
		})
	).isRequired,
	totalOutstanding: PropTypes.any,
	isEditMode: PropTypes.bool,
	previousUPIPayments: PropTypes.array,
	deliveryDate: PropTypes.object,
	outstandingAmount: PropTypes.any,
};
